
































































































































import { technicalMessageApi } from '../technical-message.api';
import { SocketIOService } from '@/socketio.service';
import ModalBox from '@/modules/core/components/ModalBox.vue';
import BaseTable from '@/modules/core/components/BaseTable';
import { Component, Prop } from 'vue-property-decorator';
import { technicalMessageTypes } from '@shared/common/types/technical-message-types';
import { format } from 'date-fns';
import { PaginationResult } from '@shared/common/types';
import { TechnicalMessage } from '../technical-message';

@Component({
  components: {
    ModalBox,
  },
})
export default class TechnicalMessagesTable extends BaseTable {
  @Prop()
  public deviceId?: string;

  @Prop()
  public createdById?: string;
  public groups = [
    {
      values: ['START_PROTECTION', 'STOP_PROTECTION'],
      label: 'Protection',
      checked: false,
    },
    {
      values: ['USER_LOGIN', 'USER_LOGOUT'],
      label: 'Log in/out',
      checked: false,
    },
  ];

  public technicalMessageTypes = [
    { id: undefined, label: '' },
    ...technicalMessageTypes
      .reduce((msgItems: any[], msgType) => {
        const group = this.groups.find((groupItem) =>
          groupItem.values.includes(msgType.id),
        );

        if (group) {
          if (!group.checked) {
            msgItems.push({
              id: group.values.join(','),
              label: group.label,
            });
            group.checked = true;
          }
        } else {
          msgItems.push(msgType);
        }

        return msgItems;
      }, [])
      .sort((t1, t2) => t1.label.localeCompare(t2.label)),
  ];

  public lastNewTechnicalMessagesReset = new Date();
  public format = format;
  public newTechnicalMessages = 0;
  public technicalMessageListener = async (): Promise<void> => {
    if (this.pagination.page === 1) {
      await this.getData();
      this.resetNewTechnicalMessagesCount();
    } else {
      this.newTechnicalMessages++;
    }
  }

  public resetNewTechnicalMessagesCount(): void {
    this.newTechnicalMessages = 0;
    this.lastNewTechnicalMessagesReset = new Date();
    this.pagination.page = 1;
  }

  public mounted(): void {
    SocketIOService.sockets.backend.on(
      'technicalMessage',
      this.technicalMessageListener,
    );
    this.getData();
  }

  public beforeDestroy(): void {
    SocketIOService.sockets.backend.off(
      'technicalMessage',
      this.technicalMessageListener,
    );
  }

  public buildFilters(gridFilters: any): void {
    this.$super(BaseTable).buildFilters(gridFilters);

    if (this.deviceId) {
      this.filters.deviceId = this.deviceId;
    }

    if (this.createdById) {
      this.filters.createdById = this.createdById;
    }
  }

  public async fetchData(): Promise<PaginationResult<TechnicalMessage>> {
    return await technicalMessageApi.findAll({
      ...this.pagination,
      ...this.filters,
      sort: this.sort,
    });
  }

  public get exportUrl(): string {
    return technicalMessageApi.getExportUrl();
  }
}
